// @flow

import getSessionToken from "../utils/getSessionToken";

const PageTracker = url => {
    getSessionToken().then(token => {
        fetch("/api/content/read", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-Token": token,
            },
            method: "POST",
            body: JSON.stringify({
                url: url || document.location.pathname,
            }),
        })
            .then(function(res) {
                console.log(res);
            })
            .catch(function(res) {
                console.log(res);
            });
    });
};

export default PageTracker;
